import ProtectedRoute from "./protectedRoute";
import University from "../pages/admin/university";
import AddUniversity from "../pages/admin/addUniversity";
import SuccessStory from "../pages/admin/successStory";
import AddStory from "../pages/admin/addStory";import React from 'react'
import Dashboard from "../componets/dashboard";
import CounsellorList from "../componets/counsellor";
import UserList from "../componets/users";
import UserProfile from "../pages/user/userProfile";
import AdminProfile from "../pages/admin/adminProfile";
import AddPost from "../pages/admin/addPost";
import Advertisement from "../pages/admin/advertisements";
import AddAdvertisement from "../pages/admin/addAdvertisement";
import Post from "../pages/admin/posts";
import CounsellorTabs from "../pages/counsellor/cousellorTabs";
import {Routes,Route } from "react-router-dom";
import Wrapper from "../componets/wrapper";

const ContentRoute = () => {
  return (
   <Wrapper>
    <Routes>
        <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/counsellorlist"
        element={
          <ProtectedRoute>
            <CounsellorList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/counsellor"
        element={
          <ProtectedRoute>
            <CounsellorTabs />
          </ProtectedRoute>
        }
      />

      <Route
        path="/userlist"
        element={
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user"
        element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/post"
        element={
          <ProtectedRoute>
            <AddPost />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advertisements"
        element={
          <ProtectedRoute>
            <Advertisement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advertisement"
        element={
          <ProtectedRoute>
            <AddAdvertisement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/posts"
        element={
          <ProtectedRoute>
            <Post />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tabs"
        element={
          <ProtectedRoute>
            <CounsellorTabs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/university"
        element={
          <ProtectedRoute>
            <University />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-university"
        element={
          <ProtectedRoute>
            <AddUniversity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/success-story"
        element={
          <ProtectedRoute>
            <SuccessStory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-story"
        element={
          <ProtectedRoute>
            <AddStory />
          </ProtectedRoute>
        }
      />
    </Routes>
   </Wrapper> 
    
  )
}

export default ContentRoute